<template>
    <LoadingVue v-if="isLoading" />
    <div class="lotto" v-else>
        <TitleCommon title="lotto daily" :isShowButtonBack="true" />
        <GameLotto v-if="dataSource.length > 0" :dataSource="dataSource" :markets="markets" />
        <div v-else class="loto__no-data">
            {{ getTranslatedText('no data') }}
        </div>
    </div>
</template>
<script>
import LottoService from '@/services/loto/loto.service';
import languageMixins from '@/mixins/language-mixins';
import TitleCommon from '@/components/common/title/index.vue';
import LoadingVue from '@/components/common/loading/loading.vue';

import GameLotto from '@/components/loto/daily-lotto/index.vue';

import { isArrayEmpty } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { GameLotto, LoadingVue, TitleCommon },
    data() {
        return {
            dataSource: [],
            markets: [],
            isLoading: true,
        };
    },
    created() {
        this.$store.commit('SET_CART_GAME_EMPTY');
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const resp = await LottoService.callAllGame();

                const games = resp.responseGames?.data;
                const draws = resp.responseDraws?.data;
                if (!isArrayEmpty(games) && !isArrayEmpty(draws)) {
                    const result = draws.map((draw) => {
                        const index = games.findIndex((game) => game.game.game_id === draw.parent_id);
                        if (index !== -1) {
                            // Store the game object FIRST before modifying draw
                            const fullGameObject = games[index].game;
                            
                            draw['type'] = games[index].game.game_type;
                            draw['game_slug'] = games[index].game.slug;
                            draw['gameConfig'] = fullGameObject; // Use different property name to avoid conflicts
                        }
                        return draw;
                    });
                    
                    // Remove duplicate markets by consolidating based on market_name and market_slug
                    // Keep only "normal" type markets as the base
                    const uniqueMarkets = [];
                    const seenMarkets = new Set();
                    
                    games[0].markets.forEach((market) => {
                        const key = `${market.market_name}-${market.market_slug}`;
                        
                        // Only add if we haven't seen this market yet and it's of type "normal"
                        if (!seenMarkets.has(key) && market.market_config.type === 'normal') {
                            uniqueMarkets.push(market);
                            seenMarkets.add(key);
                        }
                    });
                    
                    this.markets = uniqueMarkets;
                    this.dataSource = result;
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/loto.scss';
</style>
